module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/GD-7de0c6d64ff3cc8eb48c7e002f7f21c7.png";